import React from 'react'
import { useSelector } from 'react-redux'
import { format } from '../../helpers/number'
import { Button, Space, Typography } from 'antd'
import { ApplicationState } from '../../store'
import { makePath } from '../../helpers/path'
import { useHistory } from 'react-router'

const { Text } = Typography

interface AffiliateLevelWidgetProps {
	amount: number
}

const AffiliateLevelWidget = ({ amount }: AffiliateLevelWidgetProps) => {
	const history = useHistory()
	const prefixState = useSelector((state: ApplicationState) => state.prefix)

	return (
		<>
			{prefixState?.info?.affiliateLevel && (
				<div className="wallet-other-card">
					<div className='wallet-other-card-inner'>
						<Space size={0}>
							<Text type="secondary">
								แนะนำเพื่อน
							</Text>
						</Space>
						<div className="wallet-other-card-amount">
							<span>฿ {format(amount)}</span>
						</div>
					</div>
					<Button
						type="primary"
						className="ant-btn-secondary reward-cashback"
						icon={<>รับ</>}
						onClick={() => history.push(makePath('/affiliate'))}
					/>
				</div>
			)}
		</>
	)
}

export default AffiliateLevelWidget
